let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Npjx")).then(() => parcelRequire('gkLsl'));